import Index from './Index.vue';
import New from './New.vue';
import Show from './Show.vue';
import Edit from './Edit.vue';

export default {
  Index,
  New,
  Show,
  Edit,
};
